import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Grid2 as Grid} from 'views/components';
import {CompactCardTable} from 'views/module';

import Card from './Card';

import JOB_SOURCES from '../../../job_source';

const List = (props) => {
  const [data, setData] = React.useState([]);
  const [lastEvaluatedKey, setLastEvaluatedKey] = React.useState();
  const [stage, setStage] = React.useState('FILL');

  const progressWrap = props.statusProgressWrap;
  const selection = props.selection;
  const reload = props.reload;
  const jobSource = props.jobSource || JOB_SOURCES.LEGACY;

  const isLoading = stage === 'LOADING';
  const sortByPriority = !!selection.sortByPriority;
  const orderedData = React.useMemo(() => {
    if (!sortByPriority) {
      return data;
    }

    const priorityRank = {
      PRIORITY_1: 1,
      PRIORITY_2: 2,
      PRIORITY_3: 3,
      PRIORITY_4: 4,
    };
    const unprioritizedRank = Number.MAX_SAFE_INTEGER;

    return [...data].sort((first, second) => {
      const firstRank = priorityRank[first.priority] ?? unprioritizedRank;
      const secondRank = priorityRank[second.priority] ?? unprioritizedRank;

      return firstRank - secondRank;
    });
  }, [data, sortByPriority]);

  const loadData = () => {
    progressWrap(async () => {
      const filter = [];

      for (const filterSelected of Object.values(selection.filter)) {
        filter.push(
            {
              key: filterSelected.filterData.key,
              value: filterSelected.optionSelected,
            },
        );
      }

      const sortBy = {
        sortKey: 'createdAt',
        sortDirection: 'DESC',
      };

      const result = await jobSource.api().queryJob(filter, sortBy, lastEvaluatedKey);
      setData((e) => {
        return [
          ...e,
          ...result.list,
        ];
      });
      setLastEvaluatedKey(result.lastEvaluatedKey);
    }, {setStage, showProgress: false});
  };

  React.useEffect(() => {
    setData([]);
    setLastEvaluatedKey(null);
    loadData();
  }, [selection.filter, reload, jobSource]);

  return (
    <Grid container>
      <CompactCardTable
        data={orderedData}
        card={Card}
        cardProps={{
          detailPath: jobSource.detailPath,
          showUnregisteredPoster: jobSource.showUnregisteredPoster,
        }}
        isLoading={isLoading}
        loadMore={loadData}
        hasMore={!!lastEvaluatedKey}
        getItemId={(item) => item.jobId || item.jobRn}
      />
    </Grid>
  );
};
List.propTypes = {
  statusProgressWrap: PropTypes.func.isRequired,
  selection: PropTypes.object.isRequired,
  reload: PropTypes.number.isRequired,
  jobSource: PropTypes.object,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(List));
